export enum MarketAdviceEnum {
    BOVESPA = 'S',
    BMF = 'F'
}